import { useSelector } from 'react-redux';
import { StageType } from '../../../../../domain/enums/stage-type';
import { StageV2 } from '../../../../../domain/interfaces/stage';
import { selectSelectedStageGroups } from '../../../../../store/stages';
import CreateStageGroupForm from './create-stage-group-form';
import { StageBracketsForm } from './stage-brackets';
import StageGroupList from './stage-group-list';
import StageStandingTabs from './stage-standing-tabs';

type StageGridProps = {
  stage: StageV2;
};

const StageGrid = ({ stage }: StageGridProps) => {
  const teamGroups = useSelector(selectSelectedStageGroups);
  const isGroupStage = stage.type === StageType.GROUP;
  const isStanding = stage.type === StageType.ROUND_ROBIN_1 || stage.type === StageType.ROUND_ROBIN_2;

  if (isGroupStage) {
    return (
      <div className="row gap-y-6">
        <CreateStageGroupForm stage={stage} />

        <StageGroupList groups={teamGroups} teams={stage.teams} />
      </div>
    );
  }

  if (isStanding) {
    return <StageStandingTabs stage={stage} />;
  }

  return (
    <div className="row gap-y-6">
      <StageBracketsForm teams={stage.teams} />
    </div>
  );
};

export default StageGrid;
